import { render, staticRenderFns } from "./StudyList.vue?vue&type=template&id=ee79328c"
import script from "./StudyList.vue?vue&type=script&lang=js"
export * from "./StudyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports